import React from "react";

interface SwipeCardLoadMoreProps {
  isLoading: boolean;
  onClick?: () => void;
  skeletonType?: "tour" | "post";
}

const SwipeCardLoadMore: React.FC<SwipeCardLoadMoreProps> = ({
  isLoading,
  onClick,
  skeletonType = "tour",
}) => {
  const skeletons = {
    tour: (
      <div className="animate-pulse rounded-md shadow-sm w-full max-w-sm flex flex-col">
        {/* Image  block */}
        <div
          className="relative grow w-full"
          style={{
            flex: 4,
          }}
        >
          {/* Image */}
          <div
            className="relative w-full bg-gray-200 rounded-t-md"
            style={{ paddingBottom: "75%" /* 4:3 aspect */ }}
          ></div>

          {/* city */}
          <div className="absolute top-2 left-2 w-full pr-2 grid-rows-2">
            <div className="inline-block text-gray-600 rounded px-3 py-1 text-xs truncate bg-gray-300 w-28 h-5">
              {""}
            </div>
          </div>

          {/*  Duration */}
          <div className="absolute top-10 left-2 w-full pr-2 grid-rows-2">
            <div className="inline-block text-gray-600 rounded px-3 py-1 text-xs truncate bg-gray-300 w-20 h-5">
              {""}
            </div>
          </div>
        </div>

        {/*  Body */}
        <div
          className="grow w-full px-3 pt-3"
          style={{
            flex: 3,
          }}
        >
          {/* Title */}

          <h2
            className="text-xl font-medium mb-2 leading-snug  hidden sm:block"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              minHeight: "3.5rem", // 2 x line-height (~1.375rem)
              maxHeight: "3.5rem",
            }}
          >
            <div className="bg-gray-200 h-10 w-full"></div>
          </h2>

          {/* Price  */}
          <div className="text-xs text-gray-600 flex items-center mb-1 h-5">
            <div className="bg-gray-200 h-5 w-3/4"></div>
          </div>
        </div>
      </div>
    ),
    post: (
      <div className="animate-pulse rounded-md shadow-sm w-full max-w-sm flex flex-col">
        {/* Image  block */}
        <div
          className="relative grow w-full"
          style={{
            flex: 4,
          }}
        >
          {/* Image */}
          <div
            className="relative w-full bg-gray-200 rounded-t-md"
            style={{ paddingBottom: "75%" /* 4:3 aspect */ }}
          ></div>

          {/* Country */}
          <div className="absolute top-2 left-2 w-full pr-2 grid-rows-2">
            <div className="inline-block text-gray-600 rounded px-3 py-1 text-xs truncate bg-gray-300 w-28 h-5">
              {""}
            </div>
          </div>
        </div>

        {/*  Body */}
        <div
          className="grow w-full px-3 pt-3"
          style={{
            flex: 3,
          }}
        >
          {/* Title */}
          <div
            className="text-xl font-medium truncate-3 mb-2"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              lineHeight: "1.75rem", // matches Tailwind's leading-5
              height: "5.5rem", // 3 lines × 1.25rem
            }}
          >
            <div className="bg-gray-200 h-10 w-full"></div>
          </div>
        </div>
      </div>
    ),
  };
  return (
    <div
      className="flex w-full mb-4 items-center justify-center bg-white border border-gray-200 rounded-lg cursor-pointer shadow-lg"
      onClick={!isLoading ? onClick : undefined}
    >
      {isLoading ? (
        skeletons[skeletonType]
      ) : (
        <div className="p-4 text-center text-gray-800 font-medium">
          Load More
        </div>
      )}
    </div>
  );
};

export default SwipeCardLoadMore;
